// Module
var code = "<p>Enable this setting to add logic to your survey and turn it smarter. This setting allows you to automatically show/hide questions, entire pages or other items that are part of your survey or merely to skip to a certain point, based on how a participant answers your questions.</p> ";
// Exports
module.exports = code;